const owns = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

export function mergeDebuggerUpdate(previous, update, tools = []) {
    const next = { ...previous, ...update };
    if (owns(update, 'journeySession')) {
        next.playbookExited = !update.journeySession?.journeyId;
        return next;
    }
    const event = update.agentEvent;
    const journeyId = previous.journeySession?.journeyId;
    // Generic agent activity, including input_message and events with a missing
    // workflowRunning flag, says nothing about whether a playbook has exited.
    if (event?.type !== 'tool_end' || event.isSubAgent || !journeyId) return next;
    const tool = tools.find(item => item.name === event.payload?.toolName && item.type === 'workflow');
    if (tool?.toolData?.workflowId !== journeyId) return next;
    let output = event.payload?.output;
    if (typeof output === 'string') {
        try { output = JSON.parse(output); } catch (_) { return next; }
    }
    if (!output || ['waiting_for_user_input', 'collecting_more_info'].includes(output.status) || output.wait_for_prompt) return next;
    if (output.result !== undefined || output.status === 'completed' || event.payload?.failed) next.playbookExited = true;
    return next;
}

export function shouldPinPlaybook(config, session, exited) {
    return Boolean(config?.stm?.metadata?.playbook && session?.journeyId && !exited);
}

export function observePlaybookSession(snapshot, journeyId, observedActive) {
    if (!snapshot || !owns(snapshot, 'journeySession')) return { observedActive, exited: false };
    const matches = snapshot.journeySession?.journeyId === journeyId;
    return { observedActive: observedActive || matches, exited: observedActive && !matches };
}
